import React, { useEffect, useState } from 'react';
import { getPromoConfig } from '../../services/promoService';

const STORAGE_KEY = 'promoModalDismissedAt';

export default function PromoModal() {
  const [open, setOpen] = useState(false);
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const run = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const forceTest = params.get('promoTest') === '1';
        const dismissedAt = localStorage.getItem(STORAGE_KEY);
        const now = Date.now();
        // reapresenta após 24h
        let canShowAgain = forceTest || (!dismissedAt || now - Number(dismissedAt) > 24 * 60 * 60 * 1000);

        const res = await getPromoConfig();
        if (res.success) {
          const data = res.data || {};
          setConfig(data);
          // valida ativa/intervalo
          const enabled = forceTest ? true : data.enabled === true;
          if (data.alwaysShow) {
            canShowAgain = true;
          }
          const withinStart = !data.startsAt || new Date(data.startsAt).getTime() <= now;
          const withinEnd = !data.endsAt || new Date(data.endsAt).getTime() >= now;
          if (enabled && withinStart && withinEnd && canShowAgain) {
            setOpen(true);
          }
        }
      } finally {
        setLoading(false);
      }
    };
    run();
  }, []);

  if (loading || !open || !config) return null;

  const close = () => {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
    setOpen(false);
  };

  const handleAction = () => {
    if (config.ctaUrl) {
      window.location.href = config.ctaUrl;
    }
    close();
  };

  const bgStyle = config.bgFrom && config.bgTo ? { background: `linear-gradient(135deg, ${config.bgFrom}, ${config.bgTo})` } : {};

  const titleWeight = Number(config.titleWeight || 700);
  const subtitleWeight = Number(config.subtitleWeight || 600);
  const descriptionWeight = Number(config.descriptionWeight || 400);
  const titleSize = config.titleSize || 'text-3xl';
  const subtitleSize = config.subtitleSize || 'text-lg';
  const descriptionSize = config.descriptionSize || 'text-base';

  return (
    <div className="fixed inset-0 z-[9998] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="relative rounded-2xl shadow-2xl w-full max-w-md overflow-hidden" style={bgStyle}>
        {config.imageUrl && (
          <div className="w-full h-48 bg-gray-100">
            <img src={config.imageUrl} alt={config.title || 'Promoção'} className="w-full h-full object-cover" />
          </div>
        )}
        <div className="p-6">
          <h3 className={`${titleSize} mb-2`} style={{ color: config.titleColor || undefined, fontWeight: titleWeight }}>{config.title || 'Promoção'}</h3>
          {config.subtitle && <p className={`${subtitleSize} mb-4`} style={{ color: config.subtitleColor || undefined, fontWeight: subtitleWeight }}>{config.subtitle}</p>}
          {config.description && <p className={`${descriptionSize} leading-relaxed mb-6`} style={{ color: config.descriptionColor || undefined, fontWeight: descriptionWeight }}>{config.description}</p>}

          <div className="flex items-center justify-between gap-3">
            {config.ctaUrl && (
              <button onClick={handleAction} className="px-4 py-2 rounded-lg font-semibold border" style={{ backgroundColor: config.ctaBg || '#ffffff', color: config.ctaTextColor || '#1f2937', borderColor: '#00000022' }}>
                {config.ctaText || 'Quero aproveitar'}
              </button>
            )}
            <div className="flex-1"></div>
            <button onClick={close} className="px-5 py-2.5 rounded-lg font-semibold" style={{ backgroundColor: config.continueBg || '#4f46e5', color: config.continueTextColor || '#ffffff' }}>
              Continuar
            </button>
          </div>
        </div>

        <button onClick={close} aria-label="Fechar" className="absolute top-3 right-3 w-8 h-8 rounded-full bg-black/60 text-white">×</button>
      </div>
    </div>
  );
}


